import { Button, Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { GridConstants } from '@/common/grid/GridConstants';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { StringUtils } from '@/common/utils/StringUtils';
import { useCallback, useEffect, useState } from 'react';

export const EntitySelectDialog = ({ data, closeDialog }) => {

  const rsrc = useRsrc();

  const [entityDef, setEntityDef] = useState();
  const [selectedEntities, setSelectedEntities] = useState([]);

  useEffect(() => {
    rsrc.entityDef(data.module, data.entity).then(entityDef => {
      setEntityDef(entityDef);
    })
  }, [])

  const augFieldDefs = (fieldToFieldDef) => {
    Object.values(fieldToFieldDef).forEach(fieldDef => {
      if (['HYPERLINK', 'CODE'].includes(fieldDef.type)) {
        fieldDef.type = 'NONE';
      }
    })

    fieldToFieldDef.checkbox = GridConstants.checkbox;
    
    GridConstants.removeAuditFieldDefs(fieldToFieldDef);
  }

  const augRowsReq = useCallback((rowsReq) => {
    if (data.expr) {
      rowsReq.expr = ExprUtils.and(rowsReq.expr, data.expr)
    }
    rowsReq.query = data.query;
    rowsReq.replaceParams = data.replaceParams;
  }, [])

  const rowSelected = (event) => {
    const selectedRows = event.api.getSelectedRows();
    setSelectedEntities(selectedRows);
  }

  const submit = () => {
    closeDialog(selectedEntities);
  }

  return (
    entityDef &&
    <Dialog 
      onClose={() => closeDialog()} 
      open={true} 
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle>{'Select ' + StringUtils.toSingular(entityDef.displayName)}</DialogTitle>
      <DialogContent>
        <Box sx={{ height: '60vh' }}>
          <EntityList
            id={data.field}
            module={data.module}
            entity={data.entity}
            augFieldDefs={augFieldDefs}
            augRowsReq={augRowsReq}
            gridOptions={{
              rowSelection: 'single'
            }}
            events={{
              onRowSelected: rowSelected
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => closeDialog()} data-test-id="entity-select-cancel-button">Cancel</Button>
        <Button onClick={submit} disabled={selectedEntities.length === 0} data-test-id="entity-select-submit-button">Submit</Button>
      </DialogActions>
    </Dialog>
  )
}